import includes from 'lodash/includes';

import { localExerciseTypes } from '../components/StandaloneExercises/localExercises';

const isExternalExerciseType = (exerciseType: any) =>
  includes(localExerciseTypes, exerciseType);

export default isExternalExerciseType;
